import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "@mui/material";
import { Clock, Info } from "lucide-react";

import { UIToggle } from "../../../../ui";

import "./_EventPayrollFullShiftToggle.scss";

const EventPayrollFullShiftToggle = ({
  labels,
  checked,
  disabled,
  canEdit,
  onChange,
}) => {
  // Toggling is the only thing this section does — no edit permission, no section.
  if (!canEdit) return null;

  return (
    <div className="event-payroll-full-shift">
      <span className="event-payroll-full-shift__icon-box" aria-hidden>
        {/* lucide strokes in a 24 viewBox, so 2.6 renders the design's 1.3px at 12px. */}
        <Clock
          size={12}
          strokeWidth={2.6}
          className="event-payroll-full-shift__icon"
        />
      </span>
      <span className="event-payroll-full-shift__label text-label-md">
        {labels.label}
      </span>
      {/* Touch has no hover: open on tap and keep it up long enough to read. */}
      <Tooltip
        title={labels.tooltip}
        placement="top"
        arrow
        enterTouchDelay={0}
        leaveTouchDelay={5000}
      >
        <span className="event-payroll-full-shift__hint" tabIndex={0}>
          {/* Tooltip already sets aria-label on the focusable span. */}
          <Info size={14} aria-hidden />
        </span>
      </Tooltip>
      <UIToggle
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        inputProps={{ "aria-label": labels.label }}
        className="event-payroll-full-shift__switch"
      />
    </div>
  );
};

EventPayrollFullShiftToggle.propTypes = {
  labels: PropTypes.shape({
    label: PropTypes.string.isRequired,
    tooltip: PropTypes.string.isRequired,
  }).isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  canEdit: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

EventPayrollFullShiftToggle.defaultProps = {
  disabled: false,
  canEdit: true,
};

export default EventPayrollFullShiftToggle;
